import groups from "../../../frontend/marketing/product-features.json";
import { NavIcon } from "../components/AppShell/NavIcon";
import type { NavigationIcon } from "../navigation/navigation";

export function MarketingFeatures() {
  return (
    <section className="pm-features" id="features" aria-labelledby="pm-features-title">
      <header className="pm-section-heading">
        <span>Explore LeadCat</span>
        <h2 id="pm-features-title">One workspace. Every step of your customer journey.</h2>
        <p>From the first enquiry to the next sale, give your team the tools to move forward.</p>
      </header>
      <div className="pm-feature-grid">
        {groups.map((group, index) => (
          <article className="pm-feature-group" key={group.title}>
            <header><span aria-hidden="true">0{index + 1}</span><h3>{group.title}</h3></header>
            <ul>{group.items.map((item) => (
              <li key={item.label}>
                <span className="pm-feature-icon"><NavIcon icon={item.icon as NavigationIcon} /></span>
                <div><h4>{item.label}</h4><p>{item.benefit}</p></div>
              </li>
            ))}</ul>
          </article>
        ))}
      </div>
      <div className="pm-feature-note"><p>Availability depends on your CRM plan, enabled modules and team role.</p><a href="#pricing">Compare CRM plans <span aria-hidden="true">→</span></a></div>
    </section>
  );
}
